import React from 'react';
import { ReportExportButton } from '../ReportExportButton/ReportExportButton';
import { ReportName } from '../ReportName/ReportName';
import * as S from './AnalyticsReportsListItem.styled';
export const AnalyticsReportsListItem = ({ item, onExport }) => {
    return (React.createElement(S.Container, null,
        React.createElement(ReportName, { name: item.name, externalSource: item.externalSource }),
        item.downloadEnabled !== false && React.createElement(ReportExportButton, { onExport: onExport })));
};
